import { useLocation } from "react-router-dom"
import { CheckCircle, Calendar, Clock, Mail, Download } from "lucide-react"
import { Button } from "@/modules/shared/ui/components/button"
import { generateICS, downloadICS } from "../infrastructure/icsService"

export default function BookingConfirmedPage() {
  const location = useLocation()
  const state = location.state as {
    candidateEmail?: string
    interviewTitle?: string
    startTime?: string
    endTime?: string,
    description: string
  }

  const { candidateEmail, interviewTitle, startTime, endTime, description } = state || {}

  const handleDownloadIcs = () => {
    if (!startTime) return
    const icsContent = generateICS(
      interviewTitle ?? "Interview",
      startTime,
      endTime,
      description
    )
    downloadICS(icsContent, `${interviewTitle ?? "interview"}.ics`)
  }

  return (
    <section className="min-h-screen py-12 sm:py-16 md:py-20 bg-gradient-to-br from-slate-50 to-blue-50 flex items-center">
      <div className="px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8 inline-flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-green-100 rounded-full">
            <CheckCircle className="w-12 h-12 sm:w-14 sm:h-14 text-green-600" />
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#1b237a] to-[#1a2a8f] bg-clip-text text-transparent mb-4 sm:mb-6">
            Interview Time Slot Confirmed!
          </h1>

          {(interviewTitle || startTime) && (
            <div className="bg-card rounded-2xl shadow-xl p-6 sm:p-8 mb-6">
              {interviewTitle && (
                <div className="flex items-center justify-center gap-3 mb-4">
                  <Calendar className="w-6 h-6 text-[#1b237a]" />
                  <h2 className="text-xl sm:text-2xl font-semibold text-foreground">
                    {interviewTitle}
                  </h2>
                </div>
              )}
              {startTime && (
                <div className="flex items-center justify-center gap-3">
                  <Clock className="w-6 h-6 text-[#1b237a]" />
                  <p className="text-lg sm:text-xl text-foreground">
                    {new Date(startTime).toLocaleTimeString("en-IN", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}{" "}
                    SAST
                  </p>
                </div>
              )}
              {startTime && (
                <div className="mt-5 flex justify-center">
                  <Button
                    variant="outline"
                    onClick={handleDownloadIcs}
                    className="gap-2"
                  >
                    <Download className="w-4 h-4" />
                    Add to Calendar
                  </Button>
                </div>
              )}
            </div>
          )}

          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 sm:p-6 rounded-lg">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 flex-shrink-0 mt-0.5" />
              <p className="text-base sm:text-lg text-blue-900">
                Confirmation email sent{" "}
                {candidateEmail ? `to ${candidateEmail}` : "successfully"}!
                Check inbox for details.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
